function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "delivered",
    d: "M121.94 47.346a.714.714 0 0 1 0 1.014l-2.857 2.857a.714.714 0 0 1-1.014 0l-1.429-1.429a.717.717 0 0 1 1.014-1.014l.921.929 2.35-2.357a.714.714 0 0 1 1.014 0zm3.06 1.936a5.714 5.714 0 1 1-1.674-4.041A5.715 5.715 0 0 1 125 49.282zm-1.429 0a4.286 4.286 0 1 0-1.255 3.03 4.286 4.286 0 0 0 1.259-3.03zM125 37.853v5.714a.714.714 0 1 1-1.429 0v-5.714a1.428 1.428 0 0 0-1.429-1.429h-3.571v5a.715.715 0 0 1-.443.657.6.6 0 0 1-.271.057.715.715 0 0 1-.507-.207l-.918-.931-.921.929a.714.714 0 0 1-1.014 0l-.922-.929-.921.929a.718.718 0 0 1-1.221-.507v-5h-3.571a1.428 1.428 0 0 0-1.429 1.429v14.288a1.428 1.428 0 0 0 1.429 1.429h5.714a.714.714 0 1 1 0 1.429h-5.714A2.857 2.857 0 0 1 105 52.139V37.853A2.857 2.857 0 0 1 107.861 35h14.286A2.857 2.857 0 0 1 125 37.853zm-7.857-1.429h-4.286V39.7l.207-.214a.714.714 0 0 1 1.014 0l.921.929.921-.929a.714.714 0 0 1 1.014 0l.207.214z",
    transform: "translate(-103.004 -32.996)",
    style: {
      fill: "#0a243f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredIcon);
export default __webpack_public_path__ + "static/media/DeliveredIcon.a282c91b1f1b06360b50217e0f49e1f1.svg";
export { ForwardRef as ReactComponent };